export default "__VITE_ASSET__BULl3Y7R__"